import Requests from "@/lib/mixins/Requests";

export default {
  mixins: [Requests],
  methods: {
    getUrl (url, onSuccess, onError) {
      this.axiosGet(url, onSuccess, onError)
    },
    getUrlPromise (url) {
      return this.getPromise(url)
    },
    patchUrl (url, data, onSuccess, onError) {
      this.axiosPatch(url, data, onSuccess, onError)
    },
    patchUrlPromise (url, payload) {
      return this.patchPromise(url, payload)
    },
    putUrl (url, data, onSuccess, onError) {
      this.axiosPut(url, data, onSuccess, onError)
    },
    postUrl (url, data, onSuccess, onError) {
      this.axiosPost(url, data, onSuccess, onError)
    }
  }
}
